module.exports = __webpack_public_path__ + "static/media/npm.6f7aeee8.svg";